import * as React from "react";

const BackFilledSvgIcon = ({ size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d={size === 20 
        ? "M7.97508 4.94189L2.91675 10.0002L7.97508 15.0586"
        : "M6.37967 3.95337L2.33301 8.00004L6.37967 12.0467"
      }
      stroke="white"
      strokeWidth={size === 20 ? "1.25" : "1"}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d={size === 20 
        ? "M17.0833 10H3.05835"
        : "M13.6663 8H2.44629"
      }
      stroke="white"
      strokeWidth={size === 20 ? "1.25" : "1"}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BackFilledSvgIcon;
